// extracted by mini-css-extract-plugin
export var closeButton = "_j5-2";
export var closeButtonIcon = "_j5-3";
export var lightboxContent = "_j5-1";
export var lightboxOverlay = "_j5-0";